import './Checkbox.scss'
import { clsfy } from "../../../helpers"
import { useState, useEffect } from 'react'

const Checkbox = ({ label, value, onChange, className, color = '#EF5D14' }) => {

	const [checked, setChecked] = useState(false)

	const handleChange = () => {
		const newChecked = !checked
		setChecked(newChecked)
		onChange && onChange(newChecked)
	}

	useEffect(() => {
		if (value !== checked) {
			setChecked(value)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value])

	return (
		<label
			style={{ "--border-active": color }}
			className={clsfy(className, "checkbox path flex items-start")}
		>
			<div className={clsfy({ 'mt-1': label })}>
				<input
					type="checkbox"
					value={checked}
					checked={checked}
					onChange={handleChange}
				/>
				<svg viewBox="0 0 21 21" className={clsfy({ 'mt-1': label })}>
					<path
						d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"
					/>
				</svg>
			</div>
			{label && <span className="ml-2 text-xs text-secondary leading-5 md:leading-6" >{{ label }}</span>}
		</label>
	)
}

export default Checkbox
